/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import { Cookies } from 'react-cookie'
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx/xlsx.mjs';
import moment from 'moment'
import Swal from 'sweetalert2'
import icons_export from '../../images/export.png';
import ic_files_empathy from '../../images/ic_files_empathy.svg'
import { useHistory } from "react-router-dom";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import { Button } from 'react-bootstrap'
import { Request } from '../../service'
// import { renewToken } from '../../middleware';
import { Roles } from '../../utils/constants';
// import userManager from '../../middleware/userManager';
import Header from '../layout/Header';
import { Method, ServicePath } from '../../utils';

import { Icon, TablePagination } from '@material-ui/core';
// import ExportExcel from './ExportExcel';
const cookies = new Cookies()




const headCells = [
    { id: 'employeeid', numeric: false, disablePadding: true, label: 'Employee ID' },
    { id: 'name', numeric: true, disablePadding: false, label: 'Firstname - Lastname' },
    { id: 'email', numeric: true, disablePadding: false, label: 'Email' },
    { id: 'role', numeric: true, disablePadding: false, label: 'Role' }
];
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead className="text-muted">
            <TableRow>

                {headCells.map((headCell) => (
                    <TableCell className="text-muted text-uppercase"
                        key={headCell.id}
                        align={'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}

                        </TableSortLabel>
                    </TableCell>
                ))}
                <TableCell></TableCell>
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const UserList = () => {

    let history = useHistory();
    // const [error, setError] = useState(null);
    // const [isLoaded, setIsLoaded] = useState(false);

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);

    const [allData, setAllData] = useState([]);
    const [lists, setList] = useState(allData)


    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    function handleClickBack() {
        history.push("/");
        history.go()
    }

    useEffect(() => {
        requestRole()
        // renewToken().then(u => {
        //     cookies.set('tb_token', u.access_token, { domain: process.env.REACT_APP_DOMAIN })
        //     console.log(u)
        // })
        // userManager.events.addAccessTokenExpiring(x => {
        //     renewToken().then(u => {
        //         cookies.set('tb_token', u.access_token, { domain: process.env.REACT_APP_DOMAIN })
        //         console.log(u)
        //     })
        //     console.log('Acess token expiring event');
        //     // renewToken().then(u => {
        //     //   console.log('Acess token expiring event renew success');
        //     // });
        // });

        // userManager.events.addSilentRenewError((e) => {
        //     console.log("silent renew error", e.message);
        // });
    }, [])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    function requestRole() {
        Request(Method.GET, ServicePath.UserRoles, {}).then(res => {
            if (res.code === 200) {
                setAllData(res.result)
                setList(res.result)
            }
        }).catch(err => {
            console.log(err)
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            })
        })
    }


    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            // const newSelecteds = rows.map((n) => n.name);
            // setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    const handleClick = (event, user) => {
        history.push({
            pathname: '/user-info/' + user.employeeid,
            state: { user }
        });
        history.go()

    }

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }
    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // function goCreateRole() {
    //     history.push({
    //         pathname: '/create',
    //         search: '',
    //     })
    //     history.go(0)
    // }
    // // const handleChange = (event) => {}
    const handleSearch = (event) => {
        let value = event.target.value.toLowerCase();
        let result = [];
        result = allData.filter((data) => {
            return data.employeeid.indexOf(value) !== -1 || data.firstname.toLowerCase().indexOf(value) !== -1 || data.lastname.toLowerCase().indexOf(value) !== -1;
        });
        setList(result);
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, lists.length - page * rowsPerPage);

    const loadData = () => {
        let tempex = []
        lists.map((row, i) => {
            var apps = 'All'
            var groups = 'All'
            if (row.super_role !== Roles.SUPER) {
                apps = ""
                groups = '[ '
                if (row.groups.length > 0) {

                    row.groups.map((g, index) => {
                        groups = groups + g.name
                        apps = apps + "[ "
                        g.apps.map((a, i) => {
                            apps = apps + a.route.name + ","
                        })
                        apps = apps + " ],"

                    })
                }
                groups = groups + ' ]'
            }
            var obj = {
                "Employee ID": `${row.employeeid}`,
                "Firstname-Lastname ": `${row.firstname}  ${row.lastname}`,
                "Email": `${row.email}`,
                "Role": `${row.super_role}`,
                "Groups": groups,
                "Apps": apps         
            }
            tempex.push(obj);
        })

        const ws = XLSX.utils.json_to_sheet(tempex);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'users');
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, `users Log_${moment().format("DDMMYYYY-HH:mm:ss")}.xlsx`);
    }
    return (
        <>
            {/* 
      <div role="main" className="main-content" id="panel"  >
        <Container fluid>
          {contentRender()}
        </Container>
      </div> */}
            <Header />

            <div className="container-fluid">
                <div className="row">

                    {/* <Sidebar /> */}
                    <main role="main" className="col-md-12 ml-sm-auto col-lg-12 px-md-4 mb-5">
                        <div className="pt-3 pb-2 mb-3">
                            {cookies.get('profile') ? (cookies.get('profile').super_role === Roles.SUPER ?
                                <div className="d-flex justify-content-between" >

                                    <div className="flex-column">
                                        <Button onClick={handleClickBack} variant="link" className="p-0" >
                                            <p className="text-muted mb-1" style={{ fontSize: "14px" }} >
                                                <Icon style={{ paddingTop: "6px" }}>keyboard_arrow_left</Icon>Back
                                            </p>
                                        </Button>
                                        <h4 className="ml-3 heading-content">Management User</h4>
                                    </div>

                                    <div className="d-flex justify-content-end mt-3">
                                        <div className="d-flex bd-highlight">
                                            <div className="flex-grow-1 bd-highlight">

                                            </div>
                                            <div className="bd-highlight ml-4">
                                                <form className="form-inline">
                                                    <div className="d-flex align-items-center">
                                                        {/* <div className="input-group-prepend"> */}
                                                        <div className="position-absolute mx-2"><SearchIcon></SearchIcon></div>
                                                        {/* </div> */}
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="inlineFormInputGroup"
                                                            placeholder="search"
                                                            style={{ "border": "1px solid #ced4da", paddingLeft: "2.25rem" }}
                                                            onChange={(e) => handleSearch(e)}
                                                        />
                                                    </div>
                                                    {/* <Button variant="light" className="ml-2 border d-flex align-items-center" onClick={goCreateRole}>
                                                        <AddIcon></AddIcon> <span className='ml-2'>
                                                        Create Group</span>
                                                    </Button> */}
                                                    <Button variant="light" className="ml-2 border" onClick={loadData}>
                                                        <img src={icons_export} width={24} alt="" />
                                                        <span className='ml-2'>
                                                            Export</span>
                                                    </Button>
                                                    <div className="form-group mx-sm-3 mb-2">

                                                    </div>
                                                </form>

                                            </div>
                                        </div>
                                    </div>

                                </div> : <p></p>) : ''}
                            {cookies.get('profile') ? (cookies.get('profile').super_role === Roles.SUPER ?
                                <Paper className="mt-2 shadow-none">
                                    <TableContainer>
                                        <Table

                                            aria-labelledby="tableTitle"
                                            size={'medium'}
                                            aria-label="enhanced table"
                                        >
                                            <EnhancedTableHead
                                                numSelected={selected.length}
                                                order={order}
                                                orderBy={orderBy}
                                                onSelectAllClick={handleSelectAllClick}
                                                onRequestSort={handleRequestSort}
                                                rowCount={lists.length}
                                            />
                                            <TableBody>

                                                {lists.length === 0 ? (
                                                    <>
                                                        <TableRow style={{ height: (15) * emptyRows }}>
                                                            <TableCell colSpan={6} className="text-center">
                                                                <img
                                                                    width={40}
                                                                    height={40}
                                                                    className="m-3"
                                                                    src={ic_files_empathy}
                                                                    alt="Generic placeholder"
                                                                />
                                                                <p>ยังไม่มีข้อมูล</p>
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                ) : (
                                                    <>

                                                        {stableSort(lists, getComparator(order, orderBy))
                                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            .map((list, index) => {
                                                                const isItemSelected = isSelected(list.name);
                                                                const labelId = `enhanced-table-checkbox-${index}`;

                                                                return (
                                                                    <TableRow
                                                                        hover
                                                                        onClick={(event) => handleClick(event, list)}
                                                                        role="checkbox"
                                                                        aria-checked={isItemSelected}
                                                                        tabIndex={-1}
                                                                        key={index}
                                                                        selected={isItemSelected}
                                                                    >

                                                                        <TableCell component="th" id={labelId} scope="row">
                                                                            {list.employeeid}
                                                                        </TableCell>
                                                                        <TableCell align="left">
                                                                            {list.firstname}  {list.lastname}
                                                                        </TableCell>
                                                                        <TableCell align="left">{list.email}</TableCell>
                                                                        <TableCell align="left">{list.super_role}</TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                    </>
                                                )
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25]}
                                        component="div"
                                        count={lists.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </Paper> : '') : ''}
                        </div >
                    </main>
                </div>
            </div>

            {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        
      </div > */}
        </>

    )
}
export default UserList